module.exports = __webpack_public_path__ + "static/media/pricing1.7e17dbc6.jpg";